<template>
  <div>
    <!-- HEADER -->
    <section id="lp-header" class="py-5">
      <div class="container text-center d-lg-flex align-items-lg-center justify-content-center py-5">
        <div>
          <div>
            <h2 class="font-size-xLarge font-weight-bold">EVENTO #08 - POESIA</h2>
          </div>
          <p class="mb-lg-0">Escreva uma poesia e concorra a prêmios exclusivos da Scriv!</p>
        </div>
      </div>
    </section> <!-- END HEADER -->
    <!-- BUTTONS -->
    <section id="buttons" class="text-center">
      <div>
        <Button
          class="btn btn-color3 mr-3"
          @click="toggleTheme"
        >
          Entenda o tema
        </Button>
        <router-link
          :to="{ name: 'posts.create', query: { tags: 'minhapoesia' } }"
          target="_blank"
          class="btn btn-primary"
          v-if="authenticated"
        >
          Escrever texto
        </router-link>
        <Button
          class="btn btn-primary"
          v-b-modal.auth-modal
          v-else
        >
          Escrever texto
        </Button>
      </div>
    </section> <!-- END BUTTONS -->
    <!-- ABOUT THEME -->
    <section
      id="about-theme"
      ref="aboutTheme"
      :class="{
        hidden: !aboutThemeVisible
      }"
    >
      <div class="container py-5 text-center text-md-left">
        <h2 class="font-size-medium font-weight-bold text-color2">O que é Poesia?</h2>
        <p>Poesia, ao contrário do que muitos pensam, não é somente um gênero com textos escritos em versos e rimas, conhecidos como Poemas, pois a Poesia pode estar também presente no formato de prosa. Em seu significado mais figurativo, ela pode ser entendida como o gênero que celebra a beleza e a estética da literatura.</p>
        <p>Os textos poéticos buscam sempre comover seu interlocutor, gerar comoção; utilizando-se de recursos como conotação, ambiguidade e estranheza, além da musicalidade e sinestesia. O narrador das poesias é conhecido como Eu Lírico.</p>
        <p>Há grande variedade nos textos poéticos, que englobam desde Poemas Épicos, como a Odisséia e a Ilíada, de Homero; os poemas de Camões; até poemas modernistas como os de Carlos Drummond de Andrade.</p>

        <h2 class="font-size-medium font-weight-bold text-color2">Qual tipo de texto devo publicar?</h2>
        <p>Serão aceitos textos em prosa ou em versos, que causem comoção e tenham cadência em sua construção, além de respeitar completamente as regras do evento. Pense em um assunto que o comova e transfira essa inspiração para seu texto!</p>
        <h2 class="font-size-medium font-weight-bold text-color2">Exemplos</h2>
        <div class="post-thumbs-listing listing-rowed items-3-per-row mt-4">
          <ul class="list-wrap">
            <li
              class="list-item"
              v-for="(item, index) in items"
              :key="index"
            >
                <PostThumbCard
                  :post="item"
                  linkTarget="_blank"
                />
            </li>
          </ul>
        </div>
        <div class="mt-3 text-center">
          <Button
            class="btn btn-primary"
            @click="toggleTheme"
          >
            Fechar
          </Button>
        </div>
      </div>
    </section> <!-- END ABOUT THEME -->
    <!-- STEPS -->
    <section id="steps" class="mt-3">
      <div class="container py-4">
        <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-between mx-md-auto col-md-11">
          <div class="step mb-5 mb-md-0">
            <img src="/images/events/icons/user_v2.png" alt="Crie perfil" />
            <p>Crie seu perfil <br/>na Scriv</p>
          </div>
          <div class="step mb-5 mb-md-0">
            <img src="/images/events/icons/write_v2.png" alt="Escreva" />
            <p>Escreva <br/>sua história</p>
          </div>
          <div class="step mb-5 mb-md-0">
            <img src="/images/events/icons/tag_v2.png" alt="Tag" />
            <p>Insira a tag<br/><span class="text-color2 font-weight-bold">minhapoesia</span></p>
          </div>
          <div class="step">
            <img src="/images/events/icons/publish_v2.png" alt="Publique" />
            <p>Clique em<br/>publicar</p>
          </div>
        </div>
      </div>
    </section> <!-- END STEPS -->
    <!-- PRIZES -->
    <div id="prizes">
      <div class="container py-3 text-center">
        <h2 class="font-size-xLarge mb-3"><span class="highlighted highlight-left">Premiações</span></h2>
        <p class="mb-5">A Scriv vai premiar as cinco melhores histórias de poesias</p>
        <div class="mx-auto col-md-11 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
          <div class="px-1 prize-item mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/08-poesia/award-caderno.jpg');"></div>
            <span>Diário de<br/>Couro</span>
          </div>
          <div class="px-1 prize-item mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/08-poesia/award-caneta.jpg');"></div>
            <span>Caneta de Pena<br/>com Tinteiro</span>
          </div>
          <div class="px-1 prize-item mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/08-poesia/award-canecas.jpg');"></div>
            <span>Caneca Personalizada</span>
          </div>
          <div class="px-1 prize-item">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/08-poesia/award-livros.jpg');"></div>
            <span>Livros<br/>Físicos</span>
          </div>
          <div class="px-1 prize-item">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/08-poesia/award-kit.jpg');"></div>
            <span>Kits<br/>Scriv</span>
          </div>
          <div class="px-1 prize-item">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/08-poesia/award-medalha.jpg');"></div>
            <span>Medalha no<br/>Perfil</span>
          </div>
        </div>
      </div>
    </div> <!-- END PRIZES -->
    <!-- JUDGES -->
    <section id="judges">
      <div class="container py-4 text-center">
        <h2 class="font-size-xLarge mb-5"><span class="highlighted highlight-left">Jurados</span></h2>
        <div class="mx-auto col-md-11 d-flex flex-column flex-md-row justify-content-center justify-content-md-center flex-md-wrap">
          <div class="col-md-4 mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/08-poesia/judge-kennedi.jpg');"></div>
            <span class="d-block font-weight-bold">Kennedi Lazzari</span>
            <p class="mb-1 font-size-small">Poeta e escritor, autor do livro "Sinta-se Poetasia" e criador do perfil @_poetasia.</p>
            <ul class="d-flex justify-content-center style-unlisted font-size-medium">
              <li class="mr-2">
                <a href="https://www.instagram.com/_poetasia/" class="link-color2" target="_blank"><i class="fa fa-instagram"></i></a>
              </li>
            </ul>
          </div>
          <div class="col-md-4 mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/08-poesia/judge-carlos.jpg');"></div>
            <span class="d-block font-weight-bold">Carlos La Terza</span>
            <p class="mb-1 font-size-small">Poeta e artesão mineiro, criador dos livros em Filtro de Café.</p>
            <ul class="d-flex justify-content-center style-unlisted font-size-medium">
              <li>
                <a href="https://www.instagram.com/poesianofiltro/" class="link-color2" target="_blank"><i class="fa fa-instagram"></i></a>
              </li>
            </ul>
          </div>
          <div class="col-md-4 mb-4 mb-md-0">
            <a href="https://scriv.com.br/jomelo/" target="_blank">
              <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/08-poesia/judge-jo.jpg');"></div>
            </a>
            <span class="d-block font-weight-bold">Jo Melo</span>
            <p class="mb-1 font-size-small">Mãe, poeta, cronista, neuroatípica e autora do livro "Hipérboles".</p>
            <ul class="d-flex justify-content-center style-unlisted font-size-medium">
              <li class="mr-2">
                <a href="https://twitter.com/jomeloescritora" class="link-color2" target="_blank"><i class="fa fa-twitter"></i></a>
              </li>
              <li>
                <a href="https://www.instagram.com/a.jomelo/" class="link-color2" target="_blank"><i class="fa fa-instagram"></i></a>
              </li>
            </ul>
          </div>
          <div class="col-md-4 mb-4 mb-md-0">

            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/08-poesia/judge-fernanda.jpg');"></div>
            <span class="d-block font-weight-bold">Fernanda Rossin</span>
            <p class="mb-1 font-size-small">Escritora e entusiasta das artes nas suas mais diferentes formas.  </p>
            <ul class="d-flex justify-content-center style-unlisted font-size-medium">
              <li>
                <a href="https://www.instagram.com/ferrossin/" class="link-color2" target="_blank"><i class="fa fa-instagram"></i></a>
              </li>
            </ul>
          </div>
          <div class="col-md-4 mb-4 mb-md-0">

            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/08-poesia/judge-carolina.jpg');"></div>
            <span class="d-block font-weight-bold">Carol Scaldelai</span>
            <p class="mb-1 font-size-small">Autora do livro "Poesia de Saturno" e criadora do perfil @poesiadesaturno.</p>
            <ul class="d-flex justify-content-center style-unlisted font-size-medium">
              <li>
                <a href="https://www.instagram.com/carolinaeomundo/" class="link-color2" target="_blank"><i class="fa fa-instagram"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- RULES -->
    <section id="rules">
      <div class="container py-5 col-md-8">
        <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Regras de participação</h2>
        <ul class="pl-5">
          <li>O texto publicado deve ter, no máximo, 500 palavras;</li>
          <li>O participante precisa escrever de um perfil próprio na Scriv, sem perfis de terceiros;</li>
          <li>O texto publicado precisa ser original e não ter sido publicado em outra plataforma;</li>
          <li>O texto publicado precisar conter a tag <strong class="text-color2">minhapoesia</strong> e estar em modo público;</li>
          <li>Cada autor poderá inscrever no evento quantos textos desejar, mas apenas um texto por autor será premiado nos cinco vencedores;</li>
          <li>Um texto previamente publicado na Scriv pode ser inscrito no evento, desde que não tenha sido inscrito em nenhum outro concurso da nossa plataforma até o momento.</li>
        </ul>
        <div v-show="rulesVisible">
          <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Condições Gerais</h2>
          <ul class="pl-5">
            <li>O texto publicado precisa respeitar as Regras de Moderação de nossa plataforma;</li>
            <li>Qualquer violação destas regras promoverá a desclassificação automática do texto;</li>
            <li>Qualquer situação não prevista nestas condições será avaliada individualmente;</li>
            <li>Não poderão participar pessoas com relações comerciais ou empregatícias com a Scriv;</li>
            <li>Não poderão participar parentes de 1º grau de qualquer membro da banca de jurados;</li>
            <li>Como o texto pode ser editado, será considerado o texto ativo e público no dia da deliberação dos jurados (conforme calendário abaixo).</li>
          </ul>
          <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Banca de Jurados</h2>
          <ul class="pl-5">
            <li>Os jurados são: Kennedi Lazzari, Carlos Terza, Jo Melo, Fernanda Rossin e Carol Scaldelai;</li>
            <li>Os jurados terão igual poder de voto e ordem de grandeza entre si, sem exceções;</li>
            <li>Os jurados não possuem relação direta com os autores e respectivos textos publicados;</li>
            <li>Os jurados não possuem conflitos de interesse em relação ao tema e premiações.</li>
          </ul>
          <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Metodologia</h2>
          <ul class="pl-5">
            <li>Todos os textos inscritos passarão por uma pré-banca formada por integrantes da Scriv;</li>
            <li>Os textos selecionados serão lidos por todos os jurados, sem interferência da Scriv;</li>
            <li>Os jurados darão uma nota de 0 a 10 para cada uma das seguintes categorias: emoção (impacto e capacidade criativa), ritmo (cadência e sonoridade) e sentido (grau de coesão);</li>
            <li>A nota final de cada texto será formulada por essas notas individuais das categorias;</li>
            <li>Os textos serão então ranqueados pela média das notas, da primeira à quinta colocação.</li>
          </ul>
          <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Premiações</h2>
          <ul class="pl-5">
            <li>Serão premiados os cinco melhores textos, de acordo com a metodologia acima;</li>
            <li>Apenas um texto por autor poderá figurar entre os cinco textos vencedores;</li>
            <li>Os textos que ficarem em 4º e 5º lugar receberão uma caneta de pena com tinteiro, um livro físico, um kit personalizado da Scriv e uma medalha de premiação no perfil;</li>
            <li>Os textos que ficarem em 2º e 3º lugar receberão uma caneta de pena com tinteiro, um diário de couro com cadeado, um livro físico, um kit da Scriv e uma medalha no perfil;</li>
            <li>O texto vencedor receberá uma caneca exclusiva, uma caneta de pena com tinteiro, um diário de couro com cadeado, um livro físico, um kit da Scriv e uma medalha no perfil;</li>
            <li>Entraremos em contato com os vencedores em até 5 (cinco) dias após a divulgação dos mesmos, pelo email cadastrado na Scriv ou via redes sociais.</li>
          </ul>
        </div>
      </div>
    </section> <!-- END RULES -->
    <div class="text-center read-more-rules position-relative">
      <Button
        class="btn btn-primary"
        @click="rulesVisible = !rulesVisible"
      >
        <span v-if="rulesVisible">Fechar</span>
        <span v-else>Ver regulamento completo</span>
      </Button>
    </div>
    <!-- DATES -->
    <section id="dates" class="py-3">
      <div class="container py-5">
        <div class="col-md-10 mx-auto d-flex flex-column flex-md-row justify-content-center justify-content-md-between text-center mt-3 text-white">
          <div class="col-md-3 mb-4 mb-md-0">
            <span class="d-block font-weight-bold font-size-large">17/06</span>
            <p class="mb-0">
              <strong>Início</strong><br/>do evento
            </p>
          </div>
          <div class="col-md-3 mb-4 mb-md-0">
            <span class="d-block font-weight-bold font-size-large">02/07</span>
            <p class="mb-0">
              <strong>Fim</strong><br/>do evento
            </p>
          </div>
          <div class="col-md-3 mb-4 mb-md-0">
            <span class="d-block font-weight-bold font-size-large">10/07</span>
            <p class="mb-0">
              <strong>Deliberação</strong><br/>dos jurados
            </p>
          </div>
          <div class="col-md-3">
            <span class="d-block font-weight-bold font-size-large">26/07</span>
            <p class="mb-0">
              <strong>Anúncio</strong><br/>dos vencedores
            </p>
          </div>
        </div>
      </div>
    </section> <!-- END DATES -->
    <!-- CTA -->
    <section>
      <div class="container py-5 text-center">
        <h2 class="font-size-xLarge">Comece a participar <br/>agora mesmo</h2>
        <router-link
          :to="{ name: 'posts.create', query: { tags: 'minhapoesia' } }"
          target="_blank"
          class="btn btn-primary mt-2"
          v-if="authenticated"
        >
          Escrever texto
        </router-link>
        <Button
          class="btn btn-primary mt-2"
          v-b-modal.auth-modal
          v-else
        >
          Escrever texto
        </Button>
      </div>
    </section> <!-- END CTA -->
  </div>
</template>

<script>

import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button'
import PostThumbCard from '@/components/post/PostThumbCard'

export default {
  components: {
    Button,
    PostThumbCard
  },
  metaInfo: {
    title: 'Evento #08 - Poesia'
  },
  data () {
    return {
      aboutThemeVisible: false,
      rulesVisible: false,
      items: [
        {
          type: 'post',
          cover: 'https://cdn.scriv.com.br/storage/images/c7eU0xxCydpeYgWfU6PwaIAwnBEEXfPYmA4D9DV9.jpg',
          slug: 'manhas-de-rios',
          title: 'manhãs de rios',
          status: 'published',
          user: {
            name: 'Ruan Santana',
            username: 'ruansd',
            avatar: 'https://cdn.scriv.com.br/storage/images/LC70DAxLCeAR8eTKL8O18LWJPjYvnuXlc57T17K6.jpg'
          }
        },
        {
          type: 'post',
          cover: 'https://cdn.scriv.com.br/storage/images/9xHNnncHiiRKUvHhEoL5ukSIbVcUNDGtX0megBSW.jpg',
          slug: '-1667495748',
          title: 'Mas afinal, o que é Poesia?',
          status: 'published',
          user: {
            name: 'Cláudia Pereira',
            username: 'claudiaescritora',
            avatar: 'https://cdn.scriv.com.br/storage/images/lz44Woh8Dkarg5mVewBcy6KAKjQLc76ZWyJusui1.jpg'
          }
        },
        {
          type: 'post',
          cover: 'https://cdn.scriv.com.br/storage/images/xgyLDHCMJFzVpG37uevOXI5XXvBTvhrBSuNnzlLu.jpg',
          slug: 'poesia-de-verdade',
          title: 'Poesia de verdade',
          status: 'published',
          user: {
            name: 'Reirazinho',
            username: 'reirazinho',
            avatar: 'https://cdn.scriv.com.br/storage/images/Yw2p2UXYVDa5f5fq5msWgftAr7VZoAYksDhkNQwU.jpg'
          }
        }
      ]
    }
  },
  computed: {
    ...mapState('auth', {
      authenticated: state => state.authenticated
    })
  },
  methods: {
    toggleTheme () {
      this.aboutThemeVisible = !this.aboutThemeVisible
    }
  }
}
</script>

<style lang="scss" scoped>
.night{
    #lp-header{
        background: url('/images/events/08-poesia/header-mobile-night.jpg?v=2') center center no-repeat;
        background-size: cover;
        @include desktop {
            background: url('/images/events/08-poesia/header-night-bg.jpg?v=2') center center no-repeat;
            background-size: cover;
        }
    }
}

#lp-header {
  background: url('/images/events/08-poesia/header-mobile.jpg?v=2') center center no-repeat;
  background-size: cover;
  @include desktop {
    background: url('/images/events/08-poesia/header-bg.jpg?v=2') center center no-repeat;
    background-size: cover;
  }
  margin-top: -3rem !important;
  position: relative;

  h2 {
    color: #eee;
    text-shadow: 0 5px 0 rgba(238,91,69, 0.46);
    position: relative;
    display: inline-block;

    &::before {
      content: '';
      background: #e5834e;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 24px;
      z-index: -1;
    }
  }

  p {
    color: #000 !important;
  }

  .container {
    position: relative;
    z-index: 2;
  }
}

#buttons {
  margin-top: -22px;
  z-index: 3;
  position: relative;
}

#about-theme {
  height: auto;
  background: #eee;
  overflow: hidden;

  p{
    color: #372b2f !important;
  }

  @include desktop {
    margin-top: -22px;
  }

  &.hidden {
    height: 0px;

    @include desktop {
      margin-top: 0;
    }
  }

  .post-card {
  -webkit-border-radius: $radius_regular;
  -moz-border-radius: $radius_regular;
  border-radius: $radius_regular;
  overflow: hidden;
  -webkit-box-shadow: 0 0 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.3);
  background-color: #fff;
  position: relative;
  color: #fff;

  &:hover {
    .image-wrap {
      .image {
        transform: scale(1.1);
      }
    }
  }

  .image-wrap {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.25);
    }

    .image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      transition: all 0.6s ease-out;
    }

    .cover-sizing {
      opacity: 0;
    }

    &.has-cover {
      &::after {
        background: rgba(0,0,0,0.1);
      }
    }
  }

  .post-info {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: left;
    padding: 15px;

    .post-title {

      h2 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: $font_size_regular;
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }
}
}

#steps {
  .step {
    position: relative;
    text-align: center;

    @include desktop {
      width: 25%;
    }

    &:last-child {
      &::after {
        display: none;
      }
    }

    &::after {
      content: '\f107';
      font-family: 'FontAwesome';
      font-size: 40px;
      color: $color2;
      position: absolute;
      bottom: -44px;
      left: calc(50% - 13px);

      @include tablet {
        content: '\f105';
        bottom: auto;
        top: 40px;
        left: auto;
        right: -25px;
      }

      @include desktop {
        right: -12px;
      }
    }
  }
}

#prizes {
  .author-image-circle.image-lg {
    width: 150px;
    height: 150px;

    @include tablet {
      width: 120px;
      height: 120px;
    }

    @include desktop {
      width: 130px;
      height: 130px;
    }
  }
}

#judges {
  .author-image-circle.image-lg {
    width: 150px;
    height: 150px;

    @include tablet {
      width: 120px;
      height: 120px;
    }

    @include desktop {
      width: 150px;
      height: 150px;
    }
  }
}

#prizes {
  .prize-item {
    @include desktop {
      width: calc(100%/6);
    }
  }
}

#rules {
  background: url('/images/events/bg-paper.jpg?v=2') top center no-repeat;
  background-size: cover;

  ul {
    li {
      list-style: disc;
    }
  }
}

.read-more-rules {
  margin-top: -22px;
  margin-bottom: -22px;
  position: relative;
  z-index: 3;
}

#dates {
  background: url('/images/events/01-causos/dates-bg.jpg') center center no-repeat;
  background-size: cover;
}

::v-deep {
  .post-thumbs-carousel {
    .post-info {
      display: none;
    }
  }
}
</style>
